module.exports = __webpack_public_path__ + "static/media/video_3.b0aba77a.mp4";